import { composeStyle } from '@xhs/yam-beer/core/system/compose'
import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

export const menuItemTextBase = {
  maxWidth: 184,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
}
export const menuFoldIconBase = {
  height: 48,
  cursor: 'pointer',
  lineHeight: 48,
  textAlign: 'center',
  bottom: 0,
  '& svg[data-style="icon"]': {
    fill: 'ash',
    stroke: 'ash',
  },
  '&:hover': {
    color: 'palette.blue.base',
    '& svg[data-style="icon"]': {
      fill: 'palette.blue.base',
      stroke: 'palette.blue.base',
    },
  },
  '&[data-active="true"]': {
    bg: '#F4F7FF',
    color: 'palette.blue.base',
    '& svg[data-style="icon"]': {
      stroke: 'palette.blue.base',
      fill: 'palette.blue.base',
    },
  },
}

export function initStyle() {
  return [
    registerThemeSpec('cmp.menu.box', {
      default: {
        width: 216,
        bg: 'palette.white.base',
        color: 'body',
        borderRadius: 8,
        fontSize: 14,
        paddingTop: 8,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      },
    }),
    registerThemeSpec('cmp.menu.item', composeStyle.var('modifier', {
      height: 48,
      px: 16,
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      cursor: 'pointer',
      '&:hover': {
        color: 'palette._VAR_.base',
        '& svg[data-style="icon"]': {
          fill: 'palette._VAR_.base',
        },
      },
      '&[data-active="true"]': {
        bg: '#F4F7FF',
        color: 'palette._VAR_.base',
        '& svg[data-style="icon"]': {
          fill: 'palette._VAR_.base',
        },
        '&:before': {
          content: '""',
          width: 4,
          height: 24,
          borderTopRightRadius: 2,
          borderBottomRightRadius: 2,
          backgroundColor: 'palette._VAR_.base',
          position: 'absolute',
          left: 0,
        },
      },
    })),
    registerThemeSpec('cmp.menu.fold', {
      default: {
        minWidth: 48,
        bg: 'palette.white.base',

        color: 'body',
        overflow: 'auto',
        fontSize: 14,
        paddingTop: 8,
      },
    }),
    registerThemeSpec('cmp.menu.fold.item', composeStyle.var('modifier', {
      height: 36,
      width: '100%',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left',
      cursor: 'pointer',
      fontSize: 12,
      '&:hover': {
        color: 'palette._VAR_.base',
        '& svg[data-style="icon"]': {
          fill: 'palette._VAR_.base',
          bg: 'palette.white.base',
        },
        '& menu-text': {
          bg: 'palette._VAR_.base',
        },
      },
      '&[data-active="true"]': {
        bg: '#F4F7FF',
        color: 'palette._VAR_.base',
        '& svg[data-style="icon"]': {
          fill: 'palette._VAR_.base',
        },

      },
    })),
  ]
}

export default initStyle
